module.exports = {

    methods: {

        isEmpty(item) {
            return item.type == 'Empty';
        },

        isText(item) {
            return item.type == 'Text';
        },

        isTextarea(item) {
            return item.type == 'Textarea';
        },

        isBoolean(item) {
            return item.type === 'Boolean';
        },

        isBooleanResult(item) {
            return item.type == 'BooleanResult';
        },

        isOption(item) {
            return item.type == 'Option';
        },

        isString(item) {
            return item.type == 'String';
        },

        isNumber(item) {
            return item.type == 'Number';
        },

        isDouble(item) {
            return item.type == 'Float';
        },

        isPercentage(item) {
            return item.type == 'Percentage';
        },

        isPercentageInput(item){
            return item.type == 'PercentageInput';
        },

        isStringResult(item) {
            return item.type == 'StringResult';
        },

        convertToPercentage(number) {
            if (number == 'N/A') return number;
            return (number * 100).toFixed(2) + '%';
        },

        getDefaultValueForDinamicQuestion(question) {
            if (this.isBoolean(question) || this.isBooleanResult(question)) {
                return false;
            }
            if (this.isNumber(question) || this.isPercentage(question)) {
                return 0;
            }
            return '';
        },
    },


    computed: {
        inputId() {
            return `dinamic-field-${this._uid}`;
        }
    }

}
